import { message } from "antd";
import { useState } from "react";
import PasswordLoginForm from "./components/password_login_form";
import SetPasswordForm from "./components/set_password_form";
import styles from "./index.module.scss";

type LoginView = "password" | "set_password";
type SetPasswordReason = "first_time" | "forgot" | null;

const Login = () => {
  const [view, setView] = useState<LoginView>("password");
  // Carried across the view switch so nobody retypes their number.
  const [phone, setPhone] = useState<string>("");
  const [reason, setReason] = useState<SetPasswordReason>(null);
  // One message instance for the whole screen: two useMessage() hooks would
  // render two overlapping context holders.
  const [messageApi, contextHolder] = message.useMessage();

  const goToSetPassword = (nextPhone: string, why: SetPasswordReason) => {
    setPhone(nextPhone);
    setReason(why);
    setView("set_password");
  };

  return (
    <section
      className={`p-4 d-flex justify-content-center align-items-center ${styles.body_bg}`}
    >
      {contextHolder}
      <div
        className={`row border rounded-5 p-4 ${styles.container_login} flex-sm-row flex-column-reverse`}
      >
        <div className="col-sm-6 col-12">
          <div className="py-4 flex-column w-100">
            <h3>
              Sign in to Material Depot for{" "}
              <span className="fw-bold"> Procurement</span>
            </h3>
            <div className="mb-3">
              {view === "password"
                ? "Welcome back! Log in to your account."
                : "Set a password for your account."}
            </div>

            {view === "password" ? (
              <PasswordLoginForm
                initialPhone={phone}
                messageApi={messageApi}
                onNeedsPasswordSetup={(p) => goToSetPassword(p, "first_time")}
                onForgotPassword={(p) => goToSetPassword(p, "forgot")}
              />
            ) : (
              <SetPasswordForm
                initialPhone={phone}
                reason={reason}
                messageApi={messageApi}
                onBackToLogin={(p) => {
                  setPhone(p);
                  setReason(null);
                  setView("password");
                }}
              />
            )}
          </div>
        </div>
        <div className="col-sm-6 col-12">
          <img
            alt="logo"
            src="/images/login_bg.png"
            className={`rounded w-100 ${styles.img_container}`}
          />
        </div>
      </div>
    </section>
  );
};

export default Login;
